import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Selamat datang kembali");
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen bg-ink-950 text-neutral-100 lg:grid-cols-2">
      <div className="relative hidden lg:block">
        <img src="/images/latimojong.jpg" alt="Gunung berkabut" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-ink-950" />
        <div className="absolute bottom-12 left-12">
          <p className="overline-label">Panel Admin</p>
          <p className="mt-3 font-display text-5xl italic">Siput Gunung</p>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-16">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="admin-login-form">
          <div>
            <p className="overline-label">Masuk</p>
            <h1 className="mt-3 font-display text-4xl">Kelola trip & pesanan</h1>
          </div>
          <label className="block space-y-2">
            <span className="text-xs uppercase tracking-[0.18em] text-neutral-500">Email</span>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="field" data-testid="admin-login-input-email" />
          </label>
          <label className="block space-y-2">
            <span className="text-xs uppercase tracking-[0.18em] text-neutral-500">Password</span>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="field" data-testid="admin-login-input-password" />
          </label>
          {error && <p className="rounded-xl border border-rose-500/30 bg-rose-500/10 px-4 py-3 text-sm text-rose-200" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} className="btn-gold w-full" data-testid="admin-login-btn-submit">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Masuk
          </button>
        </form>
      </div>
    </div>
  );
}
